import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';
import { getDeviceImage } from '../utils/UtilityFuncs';
import { connect } from "react-redux";

const genFilters = (f) => {
  return f instanceof Array && f.map((t, i) => <Badge className="tag" style={{ margin: '0.1em' }} variant="primary" key={`s${i}`}>{t.name}</Badge>);
}

const NavHeader = ({ icon, title, selectedDevice, tagFilters, tagSearch, showDevice, showFilters, compHeader, toggleSearch }) => {

  return (
    <div className="nm-page-header nav-header click-outside-exclusion" style={{ lineHeight: '24px !important', position: 'relative', marginBottom: '0', marginLeft: '5px', borderRadius: '1em', display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingLeft: '0px' }}>
      {showDevice && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', width: 'auto', cursor: 'pointer' }} onClick={toggleSearch}>
            <div className='nm-nav-header-icon-container'>
              {icon}
            </div>
            {selectedDevice
              ?
              <>
                <img className="widget-interactable-icon" alt={selectedDevice.profile} style={{ width: '40px', height: '40px', marginRight: '1em' }} src={getDeviceImage(selectedDevice.profile)} />
                <div style={{ marginRight: '2em' }}>
                  {selectedDevice.label ?
                    <div>
                      <div style={{ fontSize: '16px' }}>{selectedDevice.label}</div>
                      <div style={{ fontSize: '12px', color: '#d3d3d3', textAlign: 'center' }}>{selectedDevice.ip_address}</div>
                    </div> :
                    <div style={{ fontSize: '16px' }}>{selectedDevice.ip_address}</div>
                  }
                </div>
              </>
              :
              <span>Click to select.</span>}
          </div>
        </>
      ) || showFilters && (
        <div style={{ display: 'flex', alignItems: 'center', width: 'auto', cursor: 'pointer' }} onClick={toggleSearch}>
          <div className='nm-nav-header-icon-container'>
            {icon}
          </div>

          {
            tagFilters instanceof Array && tagFilters.length > 0 &&
            <>
              <i className={`fa-solid fa-tags fa-xl gold`} />
              <div style={{ display: 'flex', flexWrap: 'wrap', width: 'max-content', maxWidth: '250px', margin: '0 1em 0 1em', maxHeight: '50px', fontSize: '12px' }}>
                {genFilters(tagFilters)}
              </div>
            </>
          }

          {
            tagSearch &&
            <>
              <i className="fa-solid fa-magnifying-glass fa-xl gold" />
              <div style={{ display: 'flex', alignItems: 'center', margin: '0 1em 0 1em' }}>
                *{tagSearch}*
              </div>
            </>
          }

          {
            !(tagFilters instanceof Array && tagFilters.length > 0) && !tagSearch &&
            <>
              <i className="fa-solid fa-filter fa-xl widget-interactable-icon" />
              <span style={{ paddingLeft: '0.5em', paddingRight: '0.5em' }}>No Filters</span>
            </>
          }


        </div>
      ) || <><div className='nm-nav-header-icon-container'>{icon}</div><h5 className='nm-nav-header-title'>{title}</h5></>
      }
      {compHeader && compHeader}

    </div>
  );

}

const mapStateToProps = (state) => {
  return {
    selectedDevice: state.main.selectedDevice,
    tagFilters: state.main.tagFilters,
    tagSearch: state.main.tagSearch,
    showDevice: state.main.showDevice,
    showFilters: state.main.showFilters,
    compHeader: state.main.compHeader,
    icon: state.main.icon,
    title: state.main.title,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleSearch: (val) => dispatch({ type: "TOGGLE_SEARCH", payload: val }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavHeader);